'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Slot = function (_React$Component) {
  _inherits(Slot, _React$Component);

  function Slot() {
    _classCallCheck(this, Slot);

    var _this = _possibleConstructorReturn(this, (Slot.__proto__ || Object.getPrototypeOf(Slot)).call(this));

    _this.targetRefs = [];
    return _this;
  }

  _createClass(Slot, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (this.props.target === prevProps.target) return;

      var $frame = this.FrameRef;

      $frame.scrollTop = 0;

      if (this.props.target === 0) return;

      var $target = (0, _reactDom.findDOMNode)(this.targetRefs[this.props.target]);

      if ($target == null) return;

      console.log(this.props.target, $target);

      var fullScroll = (0, _reactDom.findDOMNode)(this.targetRefs[this.targetRefs.length - 1]).offsetTop;
      var targetOffset = $target.offsetTop;

      var totalScroll = targetOffset + fullScroll * (this.props.times - 1);
      console.log(totalScroll, targetOffset, fullScroll);

      var startTime = Date.now();

      var tick = function tick() {
        var elapsed = Date.now() - startTime;
        if (elapsed > _this2.props.duration) {
          _this2.props.onEnd();
          return;
        }

        var amount = _this2.props.easing(elapsed, 0, totalScroll, _this2.props.duration);
        $frame.scrollTop = amount % fullScroll;

        requestAnimationFrame(tick);
      };

      tick();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        {
          className: this.props.className,
          style: { overflow: 'hidden', position: 'relative' },
          ref: function ref(FrameRef) {
            return _this3.FrameRef = FrameRef;
          }
        },
        this.props.children.map(function (child, index) {
          return _react2.default.cloneElement(child, { ref: function ref(_ref) {
              return _this3.targetRefs[index] = _ref;
            } });
        })
      );
    }
  }]);

  return Slot;
}(_react2.default.Component);

Slot.defaultProps = {
  duration: 3000,
  easing: function easeOutQuad(elapsed, initialValue, amountOfChange, duration) {
    return -amountOfChange * (elapsed /= duration) * (elapsed - 2) + initialValue;
  },
  times: 1,
  onEnd: function onEnd() {}
};

Slot.propTypes = {
  duration: _propTypes2.default.number,
  target: _propTypes2.default.number.isRequired,
  easing: _propTypes2.default.func,
  times: _propTypes2.default.number,
  onEnd: _propTypes2.default.func
};

exports.default = Slot;